var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSplitSolve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 720.0 720.0",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l720.0 0l0 720.0l-720.0 0l0 -720.0z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l720.0 0l0 720.0l-720.0 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m5.7637796 8.146981l355.0551 0l0 333.25986l-355.0551 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffaa00",
    d: "m185.98952 139.9644l0 77.34375l18.75 0q1.953125 0 2.796875 0.75q0.859375 0.75 0.859375 1.984375q0 1.171875 -0.859375 1.953125q-0.84375 0.78125 -2.796875 0.78125l-42.96875 0q-1.953125 0 -2.796875 -0.78125q-0.84375 -0.78125 -0.84375 -1.953125q0 -1.234375 0.84375 -1.984375q0.84375 -0.75 2.796875 -0.75l18.75 0l0 -69.78125l-17.828125 5.59375q-1.3125 0.390625 -1.890625 0.390625q-0.984375 0 -1.796875 -0.8125q-0.8125 -0.8125 -0.8125 -1.921875q0 -0.984375 0.65625 -1.828125q0.515625 -0.515625 2.140625 -1.109375l25.0 -7.875z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m360.0 7.9317584l355.0551 0l0 333.25983l-355.0551 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffaa00",
    d: "m513.99133 217.09293l42.0 0l0 -2.140625q0 -1.953125 0.78125 -2.796875q0.78125 -0.859375 2.015625 -0.859375q1.171875 0 1.953125 0.859375q0.78125 0.84375 0.78125 2.796875l0 7.609375l-52.87497 0l0 -8.078125q16.671844 -14.96875 32.421844 -30.46875q7.359375 -7.21875 10.09375 -10.59375q2.734375 -3.390625 3.734375 -5.96875q1.015625 -2.578125 1.015625 -5.171875q0 -7.03125 -5.671875 -12.4375q-5.65625 -5.40625 -13.65625 -5.40625q-7.15625 0 -12.703125 4.109375q-5.53125 4.09375 -7.15625 10.15625q-0.390625 1.5625 -0.96875 2.015625q-0.78125 0.640625 -1.828125 0.640625q-1.109375 0 -1.859375 -0.734375q-0.7499695 -0.75 -0.7499695 -1.796875q0 -3.125 3.4218445 -8.453125q3.421875 -5.34375 9.4375 -8.40625q6.03125 -3.0625 12.34375 -3.0625q10.21875 0 17.578125 7.09375q7.359375 7.09375 7.359375 16.078125q0 3.78125 -1.25 6.9375q-1.234375 3.15625 -4.203125 6.90625q-2.953125 3.734375 -10.640625 11.296875q-19.265625 19.0 -31.375 29.484375l0 0.390625z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m5.7637796 360.0l355.0551 0l0 333.25983l-355.0551 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffaa00",
    d: "m194.52077 530.16113q7.546875 3.390625 11.515625 9.28125q3.984375 5.890625 3.984375 12.265625q0 9.84375 -7.984375 17.359375q-7.96875 7.515625 -19.953125 7.515625q-7.03125 0 -14.578125 -2.984375q-7.546875 -3.0 -10.546875 -6.125q-0.984375 -1.046875 -0.984375 -2.21875q0 -1.046875 0.75 -1.828125q0.75 -0.78125 1.796875 -0.78125q1.046875 0 2.34375 0.984375q10.09375 7.484375 21.359375 7.484375q9.5 0 15.90625 -5.953125q6.421875 -5.953125 6.421875 -13.25q0 -4.890625 -3.15625 -9.578125q-3.15625 -4.6875 -9.09375 -7.375q-5.921875 -2.703125 -11.96875 -2.703125q-1.953125 0 -2.8125 -0.75q-0.84375 -0.75 -0.84375 -1.984375q0 -1.171875 0.8125 -1.953125q0.828125 -0.78125 2.453125 -0.78125l4.6875 0.0625q7.359375 0 12.140625 -4.484375q4.78125 -4.5 4.78125 -10.4218445q0 -6.125 -5.015625 -10.8125q-5.015625 -4.6875 -13.078125 -4.6875q-5.671875 0 -10.421875 1.953125q-4.75 1.953125 -7.609375 5.34375q-1.046875 1.296875 -1.609375 1.59375q-0.546875 0.296875 -1.265625 0.296875q-1.109375 0 -1.890625 -0.75q-0.78125 -0.75 -0.78125 -1.796875q0 -2.609375 5.671875 -6.578125q7.875 -5.53125 17.90625 -5.53125q10.34375 0 16.984375 6.21875q6.640625 6.21875 6.640625 14.8124695q0 5.46875 -3.1875 10.359375q-3.1875 4.875 -9.375 7.796875z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m360.0 360.0l355.0551 0l0 333.25983l-355.0551 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffaa00",
    d: "m547.7101 551.78613l-36.24997 0l0 -6.328125l30.390594 -52.53122l11.40625 0l0 53.390594l4.546875 0q2.015625 0 2.859375 0.75q0.859375 0.734375 0.859375 1.984375q0 1.171875 -0.859375 1.953125q-0.84375 0.78125 -2.859375 0.78125l-4.546875 0l0 17.375l4.546875 0q2.015625 0 2.859375 0.75q0.859375 0.75 0.859375 1.984375q0 1.171875 -0.859375 1.953125q-0.84375 0.78125 -2.859375 0.78125l-20.3125 0q-2.015625 0 -2.859375 -0.78125q-0.84375 -0.78125 -0.84375 -1.953125q0 -1.234375 0.84375 -1.984375q0.84375 -0.75 2.859375 -0.75l10.21875 0l0 -17.375zm0 -5.46875l0 -47.859344l-2.859375 0l-27.671875 47.859344l30.53125 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m7.0198345 10.532181l0 74.85189l-2.3850784 2.3850784l0 -79.62205z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m7.0198345 10.532181l0 74.85189l-2.3850784 2.3850784l0 -79.62205z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m83.33481 9.293372l-75.273094 0l-2.1744776 -2.1744785l79.62205 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m83.33481 9.293372l-75.273094 0l-2.1744776 -2.1744785l79.62205 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m168.5594 9.293372l-75.273094 0l-2.1744843 -2.1744785l79.62205 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m168.5594 9.293372l-75.273094 0l-2.1744843 -2.1744785l79.62205 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m253.78267 9.293372l-75.27309 0l-2.174469 -2.1744785l79.62204 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m253.78267 9.293372l-75.27309 0l-2.174469 -2.1744785l79.62204 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m254.82814 85.38766l0 -74.85906l2.381485 -2.3814955l0 79.62205z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m254.82814 85.38766l0 -74.85906l2.381485 -2.3814955l0 79.62205z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m262.6923 10.532181l0 74.85189l-2.3850708 2.3850784l0 -79.62205z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m262.6923 10.532181l0 74.85189l-2.3850708 2.3850784l0 -79.62205z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m339.00726 9.293372l-75.2731 0l-2.174469 -2.1744785l79.62204 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m339.00726 9.293372l-75.2731 0l-2.174469 -2.1744785l79.62204 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m6.8952 95.006836l0 74.85188l-2.3850784 2.385086l0 -79.62205z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m6.8952 95.006836l0 74.85188l-2.3850784 2.385086l0 -79.62205z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m84.25563 169.8623l0 -74.859055l2.3815002 -2.3814926l0 79.62205z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m84.25563 169.8623l0 -74.859055l2.3815002 -2.3814926l0 79.62205z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m92.11979 95.006836l0 74.85188l-2.3850784 2.385086l0 -79.62205z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m92.11979 95.006836l0 74.85188l-2.3850784 2.385086l0 -79.62205z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m93.356346 170.90286l74.883736 0l2.369156 2.3691406l-79.62205 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m93.356346 170.90286l74.883736 0l2.369156 2.3691406l-79.62205 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m254.7035 169.8623l0 -74.859055l2.381485 -2.3814926l0 79.62205z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m254.7035 169.8623l0 -74.859055l2.381485 -2.3814926l0 79.62205z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m262.56766 95.006836l0 74.85188l-2.3850708 2.385086l0 -79.62205z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m262.56766 95.006836l0 74.85188l-2.3850708 2.385086l0 -79.62205z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m339.9281 169.8623l0 -74.859055l2.3815002 -2.3814926l0 79.62205z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m339.9281 169.8623l0 -74.859055l2.3815002 -2.3814926l0 79.62205z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m6.8952 179.48149l0 74.85188l-2.3850784 2.3850708l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m6.8952 179.48149l0 74.85188l-2.3850784 2.3850708l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m84.25563 254.33696l0 -74.859055l2.3815002 -2.3815002l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m84.25563 254.33696l0 -74.859055l2.3815002 -2.3815002l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m92.11979 179.48149l0 74.85188l-2.3850784 2.3850708l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m92.11979 179.48149l0 74.85188l-2.3850784 2.3850708l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m168.43477 178.24268l-75.2731 0l-2.1744766 -2.1744843l79.62205 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m168.43477 178.24268l-75.2731 0l-2.1744766 -2.1744843l79.62205 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m178.57962 255.3775l74.88374 0l2.369156 2.3691711l-79.622055 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m178.57962 255.3775l74.88374 0l2.369156 2.3691711l-79.622055 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m254.7035 254.33696l0 -74.859055l2.381485 -2.3815002l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m254.7035 254.33696l0 -74.859055l2.381485 -2.3815002l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m262.56766 179.48149l0 74.85188l-2.3850708 2.3850708l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m262.56766 179.48149l0 74.85188l-2.3850708 2.3850708l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m339.9281 254.33696l0 -74.859055l2.3815002 -2.3815002l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m339.9281 254.33696l0 -74.859055l2.3815002 -2.3815002l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m6.8952 263.95615l0 74.85187l-2.3850784 2.3851013l0 -79.62207z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m6.8952 263.95615l0 74.85187l-2.3850784 2.3851013l0 -79.62207z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m84.25563 338.8116l0 -74.85907l2.3815002 -2.3815002l0 79.62207z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m84.25563 338.8116l0 -74.85907l2.3815002 -2.3815002l0 79.62207z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m92.11979 263.95615l0 74.85187l-2.3850784 2.3851013l0 -79.62207z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m92.11979 263.95615l0 74.85187l-2.3850784 2.3851013l0 -79.62207z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m169.48022 338.8116l0 -74.85907l2.3815002 -2.3815002l0 79.62207z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m169.48022 338.8116l0 -74.85907l2.3815002 -2.3815002l0 79.62207z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m177.34306 263.95615l0 74.85187l-2.3850708 2.3851013l0 -79.62207z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m177.34306 263.95615l0 74.85187l-2.3850708 2.3851013l0 -79.62207z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m253.65804 262.71732l-75.27309 0l-2.1744843 -2.174469l79.622055 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m253.65804 262.71732l-75.27309 0l-2.1744843 -2.174469l79.622055 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m263.80423 339.85217l74.88373 0l2.3691406 2.3691406l-79.62204 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m263.80423 339.85217l74.88373 0l2.3691406 2.3691406l-79.62204 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m456.39072 9.505159l-75.2731 0l-2.174469 -2.1744776l79.62204 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m456.39072 9.505159l-75.2731 0l-2.174469 -2.1744776l79.62204 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m457.4362 85.59944l0 -74.859055l2.3814697 -2.3814955l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m457.4362 85.59944l0 -74.859055l2.3814697 -2.3814955l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m465.30032 10.743969l0 74.85188l-2.3850708 2.3850784l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m465.30032 10.743969l0 74.85188l-2.3850708 2.3850784l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m541.6153 9.505159l-75.27307 0l-2.1744995 -2.1744776l79.62207 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m541.6153 9.505159l-75.27307 0l-2.1744995 -2.1744776l79.62207 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m626.83856 9.505159l-75.27307 0l-2.1744995 -2.1744776l79.62207 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m626.83856 9.505159l-75.27307 0l-2.1744995 -2.1744776l79.62207 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m627.88403 85.59944l0 -74.859055l2.3815308 -2.3814955l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m627.88403 85.59944l0 -74.859055l2.3815308 -2.3814955l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m635.7482 10.743969l0 74.85188l-2.3851318 2.3850784l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m635.7482 10.743969l0 74.85188l-2.3851318 2.3850784l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m712.0632 9.505159l-75.27307 0l-2.1744995 -2.1744776l79.62207 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m712.0632 9.505159l-75.27307 0l-2.1744995 -2.1744776l79.62207 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m713.10864 85.59944l0 -74.859055l2.3814697 -2.3814955l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m713.10864 85.59944l0 -74.859055l2.3814697 -2.3814955l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m379.9511 95.21862l0 74.85189l-2.3850708 2.3850708l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m379.9511 95.21862l0 74.85189l-2.3850708 2.3850708l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m627.7594 170.0741l0 -74.85906l2.3815308 -2.3814926l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m627.7594 170.0741l0 -74.85906l2.3815308 -2.3814926l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m635.6236 95.21862l0 74.85189l-2.3851318 2.3850708l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m635.6236 95.21862l0 74.85189l-2.3851318 2.3850708l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m712.984 170.0741l0 -74.85906l2.3814697 -2.3814926l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m712.984 170.0741l0 -74.85906l2.3814697 -2.3814926l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m379.9511 179.69327l0 74.8519l-2.3850708 2.3850708l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m379.9511 179.69327l0 74.8519l-2.3850708 2.3850708l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m457.31155 254.54875l0 -74.85907l2.3814697 -2.381485l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m457.31155 254.54875l0 -74.85907l2.3814697 -2.381485l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m465.1757 179.69327l0 74.8519l-2.3850708 2.3850708l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m465.1757 179.69327l0 74.8519l-2.3850708 2.3850708l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m542.53613 254.54875l0 -74.85907l2.3814697 -2.381485l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m542.53613 254.54875l0 -74.85907l2.3814697 -2.381485l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m550.399 179.69327l0 74.8519l-2.3850708 2.3850708l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m550.399 179.69327l0 74.8519l-2.3850708 2.3850708l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m627.7594 254.54875l0 -74.85907l2.3815308 -2.381485l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m627.7594 254.54875l0 -74.85907l2.3815308 -2.381485l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m635.6236 179.69327l0 74.8519l-2.3851318 2.3850708l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m635.6236 179.69327l0 74.8519l-2.3851318 2.3850708l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m712.984 254.54875l0 -74.85907l2.3814697 -2.381485l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m712.984 254.54875l0 -74.85907l2.3814697 -2.381485l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m457.31155 339.0234l0 -74.85907l2.3814697 -2.3815002l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m457.31155 339.0234l0 -74.85907l2.3814697 -2.3815002l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m465.1757 264.16794l0 74.85187l-2.3850708 2.3850708l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m465.1757 264.16794l0 74.85187l-2.3850708 2.3850708l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m542.53613 339.0234l0 -74.85907l2.3814697 -2.3815002l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m542.53613 339.0234l0 -74.85907l2.3814697 -2.3815002l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m550.399 264.16794l0 74.85187l-2.3850708 2.3850708l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m550.399 264.16794l0 74.85187l-2.3850708 2.3850708l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m627.7594 339.0234l0 -74.85907l2.3815308 -2.3815002l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m627.7594 339.0234l0 -74.85907l2.3815308 -2.3815002l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m635.6236 264.16794l0 74.85187l-2.3851318 2.3850708l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m635.6236 264.16794l0 74.85187l-2.3851318 2.3850708l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m712.984 339.0234l0 -74.85907l2.3814697 -2.3815002l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m712.984 339.0234l0 -74.85907l2.3814697 -2.3815002l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m7.0198345 380.9804l0 74.8519l-2.3850784 2.3850708l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m7.0198345 380.9804l0 74.8519l-2.3850784 2.3850708l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m84.380264 455.83588l0 -74.85907l2.3815002 -2.3814697l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m84.380264 455.83588l0 -74.85907l2.3815002 -2.3814697l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m92.24442 380.9804l0 74.8519l-2.3850784 2.3850708l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m92.24442 380.9804l0 74.8519l-2.3850784 2.3850708l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m93.48098 456.87643l74.883736 0l2.369156 2.3691406l-79.62205 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m93.48098 456.87643l74.883736 0l2.369156 2.3691406l-79.62205 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m178.70425 456.87643l74.88374 0l2.369156 2.3691406l-79.62204 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m178.70425 456.87643l74.88374 0l2.369156 2.3691406l-79.62204 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m254.82814 455.83588l0 -74.85907l2.381485 -2.3814697l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m254.82814 455.83588l0 -74.85907l2.381485 -2.3814697l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m262.6923 380.9804l0 74.8519l-2.3850708 2.3850708l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m262.6923 380.9804l0 74.8519l-2.3850708 2.3850708l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m339.00726 379.74158l-75.2731 0l-2.174469 -2.174469l79.62204 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m339.00726 379.74158l-75.2731 0l-2.174469 -2.174469l79.62204 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m6.8952 465.45505l0 74.8519l-2.3850784 2.3850708l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m6.8952 465.45505l0 74.8519l-2.3850784 2.3850708l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m84.25563 540.31055l0 -74.85907l2.3815002 -2.3815002l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m84.25563 540.31055l0 -74.85907l2.3815002 -2.3815002l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m92.11979 465.45505l0 74.8519l-2.3850784 2.3850708l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m92.11979 465.45505l0 74.8519l-2.3850784 2.3850708l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m168.43477 464.21625l-75.2731 0l-2.1744766 -2.174469l79.62205 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m168.43477 464.21625l-75.2731 0l-2.1744766 -2.174469l79.62205 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m253.65804 464.21625l-75.27309 0l-2.1744843 -2.174469l79.622055 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m253.65804 464.21625l-75.27309 0l-2.1744843 -2.174469l79.622055 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m254.7035 540.31055l0 -74.85907l2.381485 -2.3815002l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m254.7035 540.31055l0 -74.85907l2.381485 -2.3815002l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m262.56766 465.45505l0 74.8519l-2.3850708 2.3850708l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m262.56766 465.45505l0 74.8519l-2.3850708 2.3850708l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m339.9281 540.31055l0 -74.85907l2.3815002 -2.3815002l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m339.9281 540.31055l0 -74.85907l2.3815002 -2.3815002l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m6.8952 549.9297l0 74.85193l-2.3850784 2.3850708l0 -79.62207z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m6.8952 549.9297l0 74.85193l-2.3850784 2.3850708l0 -79.62207z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m84.25563 624.78516l0 -74.85901l2.3815002 -2.3815308l0 79.62207z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m84.25563 624.78516l0 -74.85901l2.3815002 -2.3815308l0 79.62207z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m92.11979 549.9297l0 74.85193l-2.3850784 2.3850708l0 -79.62207z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m92.11979 549.9297l0 74.85193l-2.3850784 2.3850708l0 -79.62207z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m93.356346 625.82574l74.883736 0l2.369156 2.3691406l-79.62205 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m93.356346 625.82574l74.883736 0l2.369156 2.3691406l-79.62205 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m178.57962 625.82574l74.88374 0l2.369156 2.3691406l-79.622055 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m178.57962 625.82574l74.88374 0l2.369156 2.3691406l-79.622055 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m263.80423 625.82574l74.88373 0l2.3691406 2.3691406l-79.62204 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m263.80423 625.82574l74.88373 0l2.3691406 2.3691406l-79.62204 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m6.8952 634.40436l0 74.85187l-2.3850784 2.3850708l0 -79.62201z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m6.8952 634.40436l0 74.85187l-2.3850784 2.3850708l0 -79.62201z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m8.131755 710.30035l74.88374 0l2.369156 2.3692017l-79.62205 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m8.131755 710.30035l74.88374 0l2.369156 2.3692017l-79.62205 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m168.43477 633.1655l-75.2731 0l-2.1744766 -2.1744385l79.62205 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m168.43477 633.1655l-75.2731 0l-2.1744766 -2.1744385l79.62205 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m93.356346 710.30035l74.883736 0l2.369156 2.3692017l-79.62205 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m93.356346 710.30035l74.883736 0l2.369156 2.3692017l-79.62205 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m253.65804 633.1655l-75.27309 0l-2.1744843 -2.1744385l79.622055 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m253.65804 633.1655l-75.27309 0l-2.1744843 -2.1744385l79.622055 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m178.57962 710.30035l74.88374 0l2.369156 2.3692017l-79.622055 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m178.57962 710.30035l74.88374 0l2.369156 2.3692017l-79.622055 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m338.88263 633.1655l-75.2731 0l-2.174469 -2.1744385l79.62204 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m338.88263 633.1655l-75.2731 0l-2.174469 -2.1744385l79.62204 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m263.80423 710.30035l74.88373 0l2.3691406 2.3692017l-79.62204 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m263.80423 710.30035l74.88373 0l2.3691406 2.3692017l-79.62204 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m381.3123 457.08823l74.88376 0l2.3691406 2.3691406l-79.62204 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m381.3123 457.08823l74.88376 0l2.3691406 2.3691406l-79.62204 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m542.66077 456.04767l0 -74.85907l2.3814697 -2.3815002l0 79.62207z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m542.66077 456.04767l0 -74.85907l2.3814697 -2.3815002l0 79.62207z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m550.5236 381.1922l0 74.85187l-2.3850708 2.3851013l0 -79.62207z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m550.5236 381.1922l0 74.85187l-2.3850708 2.3851013l0 -79.62207z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m627.88403 456.04767l0 -74.85907l2.3815308 -2.3815002l0 79.62207z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m627.88403 456.04767l0 -74.85907l2.3815308 -2.3815002l0 79.62207z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m635.7482 381.1922l0 74.85187l-2.3851318 2.3851013l0 -79.62207z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m635.7482 381.1922l0 74.85187l-2.3851318 2.3851013l0 -79.62207z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m713.10864 456.04767l0 -74.85907l2.3814697 -2.3815002l0 79.62207z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m713.10864 456.04767l0 -74.85907l2.3814697 -2.3815002l0 79.62207z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m379.9511 465.66684l0 74.8519l-2.3850708 2.3850708l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m379.9511 465.66684l0 74.8519l-2.3850708 2.3850708l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m456.26608 464.42804l-75.2731 0l-2.174469 -2.1744995l79.62204 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m456.26608 464.42804l-75.2731 0l-2.174469 -2.1744995l79.62204 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m551.63556 541.56287l74.88373 0l2.3691406 2.3691406l-79.62207 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m551.63556 541.56287l74.88373 0l2.3691406 2.3691406l-79.62207 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m627.7594 540.52234l0 -74.85907l2.3815308 -2.3815002l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m627.7594 540.52234l0 -74.85907l2.3815308 -2.3815002l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m635.6236 465.66684l0 74.8519l-2.3851318 2.3850708l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m635.6236 465.66684l0 74.8519l-2.3851318 2.3850708l0 -79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m712.984 540.52234l0 -74.85907l2.3814697 -2.3815002l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m712.984 540.52234l0 -74.85907l2.3814697 -2.3815002l0 79.62204z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m542.53613 624.99695l0 -74.85901l2.3814697 -2.3815308l0 79.62207z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m542.53613 624.99695l0 -74.85901l2.3814697 -2.3815308l0 79.62207z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m550.399 550.1415l0 74.85193l-2.3850708 2.3850708l0 -79.62207z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m550.399 550.1415l0 74.85193l-2.3850708 2.3850708l0 -79.62207z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m626.7139 548.9027l-75.27307 0l-2.1744995 -2.1744995l79.62207 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m626.7139 548.9027l-75.27307 0l-2.1744995 -2.1744995l79.62207 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m712.984 624.99695l0 -74.85901l2.3814697 -2.3815308l0 79.62207z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m712.984 624.99695l0 -74.85901l2.3814697 -2.3815308l0 79.62207z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m466.41226 710.51215l74.88376 0l2.3691406 2.3692017l-79.62207 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m466.41226 710.51215l74.88376 0l2.3691406 2.3692017l-79.62207 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m551.63556 710.51215l74.88373 0l2.3691406 2.3692017l-79.62207 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m551.63556 710.51215l74.88373 0l2.3691406 2.3692017l-79.62207 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m636.8601 710.51215l74.88373 0l2.3692017 2.3692017l-79.62207 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m636.8601 710.51215l74.88373 0l2.3692017 2.3692017l-79.62207 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m712.984 709.4716l0 -74.85907l2.3814697 -2.3814697l0 79.62201z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m712.984 709.4716l0 -74.85907l2.3814697 -2.3814697l0 79.62201z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m360.80798 7.6850395l0 704.6299",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00aaff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    strokeDasharray: "16.0,6.0,2.0,6.0",
    d: "m360.80798 7.6850395l0 704.6299",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m713.9239 360.0l-707.8425 0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00aaff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    strokeDasharray: "16.0,6.0,2.0,6.0",
    d: "m713.9239 360.0l-707.8425 0",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplitSolve);
export default __webpack_public_path__ + "static/media/split-solve.ed226560132f7239a98f62fff9f0b564.svg";
export { ForwardRef as ReactComponent };